import script from "./OnlineChatMessageToClientBlockPreview.vue?vue&type=script&lang=ts&setup=true"
export * from "./OnlineChatMessageToClientBlockPreview.vue?vue&type=script&lang=ts&setup=true"

import "./OnlineChatMessageToClientBlockPreview.vue?vue&type=style&index=0&id=205e04d8&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-205e04d8"]])

export default __exports__